import React, { useEffect, useState } from "react";

// Components
import styled from "@emotion/styled";
import { Scrollbars } from "react-custom-scrollbars-2";
import { css, Global } from "@emotion/core";
import Div100vh from "react-div-100vh";
import Layout from "../../components/Layouts/Layout";
import SEO from "../../components/Utilities/SEO";
import FeaturesAudioPlayer from "../../components/Features/FeaturesAudioPlayer";
import AudioFile from "../../audio/vot-trabajo.mp3";

import artistImage from "../../images/phone-carrier/phone-carrier-intro-circle-1.png";
import songImage from "../../images/journal/anana-vestige-journal-intro-background.jpg";
import MusicBackground from "../../components/Images/musicTracks/MusicBackground";
import { colors, fonts, mediaQueries } from "../../configs/_configSite";

import TShirtsImage from "../../images/music-tracks/t-shirts.png";
import JewelryImage from "../../images/music-tracks/jewelry.png";
import AppleMusic from "../../images/music-tracks/apple-music.png";

const songs = [
  {
    title: "Godsis",
    content:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    storeLink1: "",
    storeLink2: "",
    storeLink3: "",
    artistPicture: artistImage,
    artistName: "Artist Name",
    artistBio:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have.",
    songImage,
    audioFile: AudioFile
  },
  {
    title: "My Sister",
    content:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    storeLink1: "",
    storeLink2: "",
    storeLink3: "",
    artistPicture: artistImage,
    artistName: "Artist Name",
    artistBio:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have.",
    songImage,
    audioFile: AudioFile
  },
  {
    title: "Victory",
    content:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    storeLink1: "",
    storeLink2: "",
    storeLink3: "",
    artistPicture: artistImage,
    artistName: "Artist Name",
    artistBio:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have.",
    songImage,
    audioFile: AudioFile
  },
  {
    title: "We Walk By Faith",
    content:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    storeLink1: "",
    storeLink2: "",
    storeLink3: "",
    artistPicture: artistImage,
    artistName: "Artist Name",
    artistBio:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have.",
    songImage,
    audioFile: AudioFile
  },
  {
    title: "Altin Rose",
    content:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    storeLink1: "",
    storeLink2: "",
    storeLink3: "",
    artistPicture: artistImage,
    artistName: "Artist Name",
    artistBio:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have.",
    songImage,
    audioFile: AudioFile
  },
  {
    title: "Time and Time Again",
    content:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    storeLink1: "",
    storeLink2: "",
    storeLink3: "",
    artistPicture: artistImage,
    artistName: "Artist Name",
    artistBio:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have.",
    songImage,
    audioFile: AudioFile
  }
];

const PlayersContainerStyled = styled.section`
  position: absolute;
  top: 0;
  left: -72px;
  height: 100vh;
  z-index: 1;
  width: 422px;

  section .rhap_container {
    border-radius: 0 0 16px 16px;
    border-width: 0 1px 1px 1px;
    border-color: #fff;
    border-style: solid;
    position: relative;
    background: #2e2e2e;
  }

  > div {
    > div:first-child {
      padding: 10vh 0 10vh 72px;
      display: flex;
      flex-direction: column;
    }
    > div:nth-child(2) {
      background: rgba(0, 0, 0, 0.23) !important;
      div {
        background-color: #ffffff !important;
      }
    }
    > div:last-child {
      left: 0;
      right: auto;
      max-height: 60vh;
      top: 20vh !important;
      background: rgba(0, 0, 0, 0.23) !important;
      div {
        background-color: #ffffff !important;
      }
    }
  }

  @media (max-width: ${mediaQueries.lg}px) {
    bottom: 10px;
    top: auto;
    width: 100vw;
    height: 400px;
    left: 0;
    right: 0;
    > div {
      > div:first-child {
        padding: 0 5vw 0 5vw;
        flex-direction: row;
        > article {
          margin-left: 30px;
        }
      }
    }
  }
  @media (max-width: ${mediaQueries.md}px) {
    section {
      display: block;
      .rhap_progress-section,
      .rhap_additional-controls,
      .rhap_volume-controls,
      .rhap_footer {
        display: none;
      }
      .rhap_container {
        height: 75px;
      }
    }
  }
  @media (max-width: ${mediaQueries.sm}px) {
    height: 200px;

    article {
      transform: scale(0.6);
      transform-origin: top left;
      margin-right: -150px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

const ImageStyled = styled.img`
  width: 348px;
  height: auto;
  margin-bottom: -4px;
  border-radius: 16px 16px 0 0;
  border-width: 1px 1px 0 1px;
  border-color: #fff;
  border-style: solid;
  margin-top: 30px;
`;

const ContentStyled = styled.section`
  background: #ffffff;
  grid-column: span 2;
  min-height: 412px;
  border-radius: 8px;
  z-index: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;

  justify-content: space-around;
  h1 {
    margin: 0;
  }
  p {
    font-family: Assistant;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;

    color: #7b7b7b;
  }
  small {
    font-family: Assistant;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    display: block;
    text-transform: uppercase;

    color: #7b7b7b;
  }
  strong {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;

    text-transform: uppercase;

    color: #000000;
  }
  h1 {
    font-family: Assistant;
    font-weight: 600;
    font-size: 36px;
    line-height: 47px;

    color: #000000;
  }
  div {
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding: 0 50px;
    justify-content: space-between;
  }
  a {
    display: flex;
    align-items: center;
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;

    color: #2e2e2e;
    im {
      max-width: 60px;
      margin-right: 7px;
    }
  }
  article {
    margin-top: 30px;
    background: #ffffff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 20px;
    img {
      float: left;
      max-width: 90px;
      margin-right: 20px;
      border-radius: 50%;
    }
    p {
      margin: 10px;
    }
    strong {
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      /* identical to box height */

      display: flex;
      align-items: center;
      text-transform: uppercase;

      color: #2e2e2e;
    }
  }
  @media (max-width: ${mediaQueries.md}px) {
    p {
      font-size: 12px;
      line-height: 1.2em;
    }
    div {
      padding: 0;
      a {
        font-size: 12px;
        line-height: 1.2em;
        display: flex;
        flex-direction: column;
      }
    }
  }
`;

// DATE COMPONENT ---------------------------------------------

const ProductsWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  min-height: 150px;
  margin-bottom: 15px;
  box-sizing: border-box;
  border-radius: 6px;
  overflow: hidden;
  background: white;

  @media (max-width: ${mediaQueries.md}px) {
    display: none;
  }
`;

const ProductsTitle = styled.p`
  font-family: Assistant;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0;
  margin-bottom: 15px;
`;

const ProductsLink = styled.a`
  position: absolute;
  bottom: 5px;
  right: 15px;
  font-family: Assistant;
  font-size: 0.8rem;
  color: ${colors.gold};
  text-decoration: none;
  float: right;
  transition: 0.2s;

  &:hover {
    opacity: 0.75;
  }
`;

const BoxText = styled.section`
  font-family: Assistant;
  font-size: 1rem;
`;

const products = [
  {
    image: TShirtsImage,
    title: "Sponsored T-Shirts",
    text:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts",
    link: "https://www.reliancechurch.org/espanol/"
  },
  {
    image: JewelryImage,
    title: "Support our Jewelry Crafters",
    text:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts",
    link: "https://www.reliancechurch.org/espanol/"
  }
];

const ContentWrapperStyled = styled.section`
  position: absolute;
  width: 689px;

  right: 0;
  top: calc(10vh + 30px);
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 30px;
  grid-column-gap: 30px;

  @media (max-width: ${mediaQueries.lg}px) {
    right: calc(50vw - 345px);
    bottom: 400px;
    top: auto;
  }
  @media (max-width: ${mediaQueries.sm}px) {
    max-width: 120%;
    transform: scale(0.8);
    transform-origin: bottom left;
    left: 2.2%;
    top: auto;
    bottom: 210px;
    max-height: calc(100vh - 300px);
    overflow: auto;
    border-radius: 8px;
  }
`;

const PageStyled = styled(Div100vh)`
  position: absolute;
  z-index: 1;
  left: calc(50vw - 535px);
  width: 1120px;
  top: 0;
  height: 100vh;
  @media (max-width: ${mediaQueries.xl}px) {
    width: 1090px;
  }
  @media (max-width: ${mediaQueries.lg}px) {
    width: 100vw;
    left: 0;
  }
`;

export default () => {
  const [selectedSong, setSelectedSong] = useState(false);
  const [showTracks, setShowTracks] = useState(false);
  const currentSong = songs[selectedSong];
  useEffect(() => {
    setShowTracks(true);
    return () => {
      setShowTracks(false);
    };
  }, []);
  return (
    <Layout scrollLock>
      <SEO
        title="Know Believe Fulfill | Anana Vestige"
        description="Come discover a lifestyle to KNOW how much value you possess, to BELIEVE in the truth of who you are, and to FULFILL the great task you have been given."
      />
      <Global
        styles={{
          ".nav-item-music-player": {
            color: "white"
          }
        }}
      />
      <PageStyled>
        <PlayersContainerStyled>
          {showTracks && (
            <Scrollbars>
              {songs.map((song, idx) => (
                <article
                  onClick={() => setSelectedSong(idx)}
                  role="presentation"
                >
                  <ImageStyled src={song.songImage} />
                  <FeaturesAudioPlayer
                    audio={song.audioFile}
                    title={song.title}
                    link={song.storeLink1}
                    inPage
                    onPlay={() => setSelectedSong(idx)}
                  />
                </article>
              ))}
            </Scrollbars>
          )}
        </PlayersContainerStyled>
        <ContentWrapperStyled>
          <ContentStyled
            css={{
              alignItems: selectedSong === false ? "center" : "flex-start"
            }}
          >
            {selectedSong === false && (
              <>
                <h1
                  css={{
                    fontFamily: fonts.primary,
                    fontSize: 64,
                    fontWeight: 500,
                    textAlign: "center"
                  }}
                >
                  Music For Rememberence
                  <br />
                  Don&#39;t Forget Me
                </h1>
                <p css={{ maxWidth: 530 }}>
                  We get it... It’s hard sometimes to feel and embrace the truth
                  that we are valued and made to shine with eachother by using
                  the gifts we have from a walk thats uniquely our own. We need
                  to remember from where that vestige of glory comes, and come
                  together whenever we see it fade. So be encouraged and let
                  that light shine out in the world, wear your crown!
                </p>
                <p css={{ textAlign: "center" }}>
                  <strong>Choose A Track To Begin</strong>
                </p>
              </>
            )}
            {selectedSong !== false && (
              <>
                <h1>
                  <small>Now Playing:</small>
                  {currentSong.title}
                </h1>
                <p>{currentSong.content}</p>
                <small>Discover or Purchase On:</small>
                <div>
                  <a href={currentSong.songLink1}>
                    <img src={AppleMusic} alt="Apple Music Logo" />
                    Apple Music
                  </a>
                </div>
                <article>
                  <img src={currentSong.artistPicture} alt="Artist" />
                  <strong>{currentSong.artistName}</strong>
                  <p>{currentSong.artistBio}</p>
                </article>
              </>
            )}
          </ContentStyled>
          {products.map(item => (
            <ProductsWrapper>
              <div
                css={css`
                  min-height: 100px;
                  width: 250px;

                  background-image: url(${item.image});
                  background-size: cover;
                `}
              />
              <div
                css={css`
                  padding: 15px;
                `}
              >
                <ProductsTitle>{item.title}</ProductsTitle>
                <BoxText>{item.text}</BoxText>
                {item.link.length > 0 && (
                  <ProductsLink href={item.link}>
                    go to shop
                    <svg
                      css={css`
                        position: relative;
                        margin-left: 10px;
                        top: 5px;
                      `}
                      width="11"
                      height="18"
                      viewBox="0 0 11 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.58578 7.58578C10.3668 8.36683 10.3668 9.63316 9.58579 10.4142L3.41422 16.5858C2.15429 17.8457 1.80289e-06 16.9534 1.543e-06 15.1716L-2.57375e-07 2.82843C-5.1727e-07 1.04662 2.15428 0.154283 3.41421 1.41421L9.58578 7.58578Z"
                        fill="#D7B401"
                      />
                    </svg>
                  </ProductsLink>
                )}
              </div>
            </ProductsWrapper>
          ))}
        </ContentWrapperStyled>
      </PageStyled>
      <MusicBackground />
    </Layout>
  );
};
